import { render, staticRenderFns } from "./depthGraph.vue?vue&type=template&id=72479fc6&scoped=true&"
import script from "./depthGraph.vue?vue&type=script&lang=js&"
export * from "./depthGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72479fc6",
  null
  
)

export default component.exports